module.exports = __webpack_public_path__ + "../resources/images/floppy-disk-illustration-8b97e4f79367e70ed640782de6087c5a.svg";